module.exports = __webpack_public_path__ + "f45d708971917347a2db96a52a1a2c04.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/components/LoginDialog/images/img-dialog-signup.svg
// module id = 1182
// module chunks = 2